import { Divider, Stack, Text, Box, Button } from '@ltvco/refresh-lib/theme';
import { KeyboardArrowDown } from '@mui/icons-material';
import { useState, useContext } from 'react';

import { NUMBER_OF_TEASER_RESULTS_TO_SHOW } from 'components/ChatBV/constants';
import { ChatLayoutContext } from 'components/ChatBV/context';
import { DocketEntry } from 'routes/Dashboard/CourtCases/v2/types';
import { formatCourtDateWithTime } from 'routes/Dashboard/CourtCases/v2/utils';

import { StyledButton } from '../MessageTeaser';

import { NumberText, DarkenedBox } from './components';

type MessageDocketEntriesProps = {
  docketEntries: DocketEntry[];
  courtCaseId: string;
};

export const MessageDocketEntries = ({
  docketEntries,
  courtCaseId,
}: MessageDocketEntriesProps) => {
  const { reportState } = useContext(ChatLayoutContext);
  const { openCourtCase, handleCourtCaseClick } = reportState;
  const [amountOfResultsToShow, setAmountOfResultsToShow] = useState<number>(
    NUMBER_OF_TEASER_RESULTS_TO_SHOW
  );

  const handleViewAttachmentsClick = () => {
    handleCourtCaseClick(courtCaseId);
  };

  return (
    <Stack spacing={2} divider={<Divider />}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
        }}
      >
        <Text fontWeight="bold">Docket Entries</Text>
        <StyledButton
          variant="outlined"
          size="small"
          onClick={handleViewAttachmentsClick}
          disabled={openCourtCase}
        >
          View Attachments
        </StyledButton>
      </Box>
      {docketEntries
        .slice(0, amountOfResultsToShow)
        .map((docketEntry, index) => {
          return (
            <Box
              key={docketEntry.id}
              sx={{ display: 'flex', width: '100%', gap: 2, padding: 2 }}
            >
              <NumberText># {index + 1}</NumberText>
              <Stack spacing={0.5} sx={{ width: '100%' }}>
                <Text fontWeight="bold">
                  Date Filed: {formatCourtDateWithTime(docketEntry.date_filed)}
                </Text>
                <Text>{docketEntry.description}</Text>
                <DarkenedBox>
                  <Text variant="body2" color="text.secondary">
                    Main Document{' '}
                    {docketEntry?.recap_documents[0]?.description
                      ? `- ${docketEntry?.recap_documents[0]?.description}`
                      : ''}
                  </Text>
                </DarkenedBox>
              </Stack>
            </Box>
          );
        })}
      {docketEntries.length > amountOfResultsToShow && (
        <Button
          variant="outlined"
          size="small"
          onClick={() =>
            setAmountOfResultsToShow(
              amountOfResultsToShow + NUMBER_OF_TEASER_RESULTS_TO_SHOW
            )
          }
        >
          Show More
          <KeyboardArrowDown />
        </Button>
      )}
    </Stack>
  );
};
